import React from "react";
import config from '../config';
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { useAuth } from "../auth/AuthContext";

export const WithDataFetcher = (Component) => (props) => {
  /* eslint-disable-next-line */
  const { getAccessTokenSilently: getToken } = useAuth0();
    /* eslint-disable-next-line */
  const { user, getUserProfileIdHeader } = useAuth();

  const getApiUrl = (request) => `${config.apiUrl}/practice/${user?.profile?.practiceId || 'unknown'}/${request}`;

  const parseValidationError = (data) => {
    if (data && data.forEach) {
      const error = {};
      error.errors = {};
      data.forEach((e) => {
        if (e && e.FieldName) {
          const keyName =
            e.FieldName.charAt(0).toLowerCase() + e.FieldName.slice(1);
          if (Object.keys(error.errors).includes(keyName)) {
            error.errors[keyName] += e.Message;
            error.errors[keyName] += "\n";
          } else {
            error.errors[keyName] = e.Message;
            error.errors[keyName] += "\n";
          }
        }
      });
      return error;
    }
  };

  const handleError = (err) => {
    if (err.response.status === 422) {
      return parseValidationError(err.response.data);
    }
    throw new Error("Unable to process request");
  };

  const getThenResolver = async (request, params) => {
    const token = await getToken();
    const externalObjectIdHeader = getUserProfileIdHeader();
    return axios
      .get(getApiUrl(request), {
        headers: {
          'Authorization': 'Bearer ' + token,
          ...externalObjectIdHeader
        },
        params: params ?? {},
      })
      .then((res) => res.data)
      .catch((err) => {
        throw new Error("Unable to process request");
      });
  };

  const postThenResolver = async (request, params) => {
    const token = await getToken();
    const externalObjectIdHeader = getUserProfileIdHeader();
    return axios
      .post(getApiUrl(request), JSON.stringify(params), {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': 'Bearer ' + token,
          ...externalObjectIdHeader
        },
      })
      .then((res) => res.data)
      .catch((err) => handleError(err));
  };

  const postFormDataThenResolver = async (request, params) => {
    const token = await getToken();
    const externalObjectIdHeader = getUserProfileIdHeader();
    return axios
      .post(getApiUrl(request), params, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + token,
          ...externalObjectIdHeader
        },
      })
      .then((res) => res.data)
      .catch((err) => handleError(err));
  };

  const putThenResolver = async (request, params) => {
    const token = await getToken();
    const externalObjectIdHeader = getUserProfileIdHeader();
    return axios
      .put(getApiUrl(request), JSON.stringify(params), {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': 'Bearer ' + token,
          ...externalObjectIdHeader
        },
      })
      .then((res) => res.data)
      .catch((err) => handleError(err));
  };

  const putFormDataThenResolver = async (request, params) => {
    const token = await getToken();
    const externalObjectIdHeader = getUserProfileIdHeader();
    return axios
      .put(getApiUrl(request), params, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + token,
          ...externalObjectIdHeader
        },
      })
      .then((res) => res.data)
      .catch((err) => handleError(err));
  };

  const deleteThenResolver = async (request, params) => {
    const token = await getToken();
    const externalObjectIdHeader = getUserProfileIdHeader();
    return axios
      .delete(getApiUrl(request), {
        data: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': 'Bearer ' + token,
          ...externalObjectIdHeader
        },
      })
      .then((res) => res.data)
      .catch((err) => handleError(err));
  };

  return (
    <Component
      {...props}
      getThenResolver={getThenResolver}
      postThenResolver={postThenResolver}
      postFormDataThenResolver={postFormDataThenResolver}
      putThenResolver={putThenResolver}
      putFormDataThenResolver={putFormDataThenResolver}
      deleteThenResolver={deleteThenResolver}
    />
  );
};
